module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-700-greek486.214de9c.woff2";